import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api/api";
import "./stylesheet/AgendarEvento.css";
import logoSvg from "../assets/logo.svg"; // Importando a logo para o padrão

const RESOURCES = [
  { id: "projetor", label: "Projetor" },
  { id: "som", label: "Sistema de Som" },
  { id: "microfone", label: "Microfone" },
  { id: "notebook", label: "Notebook" },
  { id: "outros", label: "Outros" },
];

export default function AgendarEvento() {
  const navigate = useNavigate();

  const initialFormState = {
    requester_name: "",
    sector: "",
    event_name: "",
    event_type: "",
    location: "",
    start_datetime: "",
    end_datetime: "",
    resources: [],
    description: "",
    additional_notes: "",
  };

  const [formData, setFormData] = useState(initialFormState);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  function handleResourceToggle(id) {
    setFormData((prev) => ({
      ...prev,
      resources: prev.resources.includes(id)
        ? prev.resources.filter((r) => r !== id)
        : [...prev.resources, id],
    }));
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      const response = await api.post("tickets/createEvent.php", formData);

      if (response.data.success) {
        setShowSuccess(true);
        setFormData(initialFormState);

        setTimeout(() => {
          setShowSuccess(false);
          navigate("/portal");
        }, 2000);
      } else {
        alert(response.data.message || "Erro ao agendar evento");
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error(error);
      alert("Erro de conexão com o servidor");
      setIsSubmitting(false);
    }
  }

  return (
    <div className="event-page">
      {/* HEADER PADRONIZADO (IDÊNTICO AO DE CHAMADOS) */}
      <header className="portal-header">
        <div className="header-logo-group" onClick={() => navigate("/portal")} style={{ cursor: "pointer" }}>
          <img src={logoSvg} alt="Logo" className="portal-logo-svg" />
        </div>
        <div className="header-nav-info">
          <button className="back-link-text" onClick={() => navigate("/portal")}>
            Voltar ao Portal
          </button>
        </div>
      </header>

      <main className="event-container">
        {/* INTRODUÇÃO DA PÁGINA FORA DO CARD */}
        <div className="page-intro">
          <h1 className="header-title">Agendar Evento</h1>
          <p className="page-subtitle">Reserve espaço e recursos para sua atividade.</p>
        </div>

        <form onSubmit={handleSubmit} className="event-card">
          <h2 className="card-main-title">Informações do Evento</h2>

          {/* DADOS SOLICITANTE */}
          <section className="form-section">
            <h3 className="section-title">Dados do Solicitante</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Nome da Pessoa *</label>
                <input
                  type="text"
                  required
                  value={formData.requester_name}
                  onChange={(e) =>
                    setFormData({ ...formData, requester_name: e.target.value })
                  }
                  placeholder="Nome completo"
                />
              </div>

              <div className="form-group">
                <label>Setor</label>
                <select
                  value={formData.sector}
                  required
                  onChange={(e) =>
                    setFormData({ ...formData, sector: e.target.value })
                  }
                >
                  <option value="" disabled hidden>
                    Selecione o setor
                  </option>
                  <option value="Pedagógico Coordenação">Pedagógico Coordenação</option>
                  <option value="Administrativo">Administrativo</option>
                  <option value="Pedagógico Sala de Aula">Pedagógico Sala de Aula</option>
                </select>
              </div>
            </div>
          </section>

          {/* DETALHES EVENTO */}
          <section className="form-section pt-border">
            <h3 className="section-title">Detalhes do Evento</h3>

            <div className="form-grid">
              <div className="form-group">
                <label>Nome do Evento *</label>
                <input
                  type="text"
                  placeholder="Ex: Workshop de TI"
                  required
                  value={formData.event_name}
                  onChange={(e) =>
                    setFormData({ ...formData, event_name: e.target.value })
                  }
                />
              </div>

              <div className="form-group">
                <label>Tipo de Evento *</label>
                <select
                  required
                  value={formData.event_type}
                  onChange={(e) =>
                    setFormData({ ...formData, event_type: e.target.value })
                  }
                >
                  <option value="" disabled hidden>
                    Selecione o tipo
                  </option>
                  <option value="Reunião">Reunião</option>
                  <option value="Palestra">Palestra</option>
                  <option value="Apresentação">Apresentação</option>
                  <option value="Formatura">Formatura</option>
                  <option value="Esportivo">Evento Esportivo</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label>Localização *</label>
              <input
                type="text"
                placeholder="Ex: Auditório, Quadra"
                required
                value={formData.location}
                onChange={(e) =>
                  setFormData({ ...formData, location: e.target.value })
                }
              />
            </div>

            <div className="form-grid">
              <div className="form-group">
                <label>Data/Hora Início *</label>
                <input
                  type="datetime-local"
                  required
                  value={formData.start_datetime}
                  onChange={(e) =>
                    setFormData({ ...formData, start_datetime: e.target.value })
                  }
                />
              </div>

              <div className="form-group">
                <label>Data/Hora Término *</label>
                <input
                  type="datetime-local"
                  required
                  value={formData.end_datetime}
                  onChange={(e) =>
                    setFormData({ ...formData, end_datetime: e.target.value })
                  }
                />
              </div>
            </div>
          </section>

          {/* RECURSOS */}
          <section className="form-section pt-border">
            <h3 className="section-title">Recursos Necessários</h3>
            <div className="resources-grid">
              {RESOURCES.map((r) => (
                <label
                  key={r.id}
                  className={`resource-item ${
                    formData.resources.includes(r.id) ? "active" : ""
                  }`}
                >
                  <input
                    type="checkbox"
                    checked={formData.resources.includes(r.id)}
                    onChange={() => handleResourceToggle(r.id)}
                  />
                  <span>{r.label}</span>
                </label>
              ))}
            </div>
          </section>

          <div className="form-group">
            <label>Descrição</label>
            <textarea
              placeholder="Descrição breve do evento..."
              className="form-textarea"
              value={formData.description}
              onChange={(e) =>
                setFormData({ ...formData, description: e.target.value })
              }
            />
          </div>

          <div className="form-group">
            <label>Notas Adicionais</label>
            <textarea
              placeholder="Observações importantes..."
              className="form-textarea"
              value={formData.additional_notes}
              onChange={(e) =>
                setFormData({ ...formData, additional_notes: e.target.value })
              }
            />
          </div>

          <button 
            type="submit" 
            className={`submit-button ${isSubmitting ? "loading" : ""}`} 
            disabled={isSubmitting}
          >
            {isSubmitting ? "Agendando..." : "Finalizar Agendamento"}
          </button>
        </form>
      </main>

      {showSuccess && (
        <div className="success-overlay">
          <div className="success-popup">
            <div className="success-icon">✓</div>
            <h2>Evento Agendado!</h2>
            <p>Sua reserva foi processada com sucesso.</p>
          </div>
        </div>
      )}
    </div>
  );
}